import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { cachedActiveOrganisation, cachedMe, fetchMe, readSession } from "../../utils/organisationApi";

// Shown for every Super Admin session, including the organisations console and a customer's organisation
const SupportSessionBanner = () => {
  const onOrganisations = useLocation().pathname === "/admin/organisations";
  const session = readSession();
  const [organisationName, setOrganisationName] = useState(
    cachedMe()?.organisation?.name || cachedActiveOrganisation()?.name || ""
  );

  // Entering an organisation starts a fresh session, so the name isn't cached yet
  useEffect(() => {
    if (organisationName) return;
    fetchMe()
      .then((me) => setOrganisationName(me?.organisation?.name || ""))
      .catch(() => {});
  }, [organisationName]);

  const inOrganisation = Boolean(organisationName || session.organisationId);

  // A Super Admin inside an organisation they belong to isn't there as support, so there is nothing to announce
  if (session.organisationId && !session.isSupportSession) return null;

  return (
    <div role="status" className="w-full flex flex-wrap items-center justify-between gap-2 px-4 sm:px-6 max-sm:pl-12 py-2 bg-[#fff4d6] text-[#7a5300] text-sm border-b border-[#f0d68a]">
      <span>
        {inOrganisation ? (
          <>
            You're in <span className="font-semibold">{organisationName || "a customer organisation"}</span> organisation
          </>
        ) : (
          <>You're signed in as Sift Hire support.</>
        )}
      </span>
    </div>
  );
};

export default SupportSessionBanner;
